import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../VolunteeringFiltersModal.module.scss'
import { LocationFilterProps } from '../VolunteeringFiltersModal.types'

import { Box, Flex, Select, Typography } from '@percent/lemonade'
import { OpportunityLocationTypeDto } from '@percent/workplace-giving/api/opportunity/dto'
import { Chip } from '@percent/workplace-giving/common/components/Chip/Chip'

export function LocationFilter({ selectedFilters, setSelectedFilters, countries }: LocationFilterProps) {
  const { t } = useTranslation()

  const locationTypeFilters = useMemo(() => {
    return [
      {
        label: t('workplace_giving.volunteering.filter.all'),
        value: undefined
      },
      {
        label: t('workplace_giving.volunteering.filter.inPerson'),
        value: OpportunityLocationTypeDto.Offline
      },
      {
        label: t('workplace_giving.volunteering.filter.virtual'),
        value: OpportunityLocationTypeDto.Virtual
      }
    ]
  }, [t])

  return (
    <>
      <Box>
        <Typography className={styles.FiltersSectionTitle}>
          {t('workplace_giving.volunteering.filters.location')}
        </Typography>
        <Flex gap="0.5rem">
          {locationTypeFilters.map(filter => (
            <Chip
              key={filter.label}
              testId={`locationTypeFilter-${filter.value}`}
              label={filter.label}
              classNames={styles.FiltersChip}
              disabled={selectedFilters.locationType === filter.value}
              handleClick={() => {
                setSelectedFilters({
                  ...selectedFilters,
                  locationType: filter.value
                })
              }}
            />
          ))}
        </Flex>
      </Box>
      <Box>
        <Typography className={styles.FiltersSectionTitle}>
          {t('workplace_giving.volunteering.filters.country')}
        </Typography>
        <Select
          placeholder={t('workplace_giving.wizard.country.placeholder') as string}
          searchable
          defaultValue={countries.find(option => option.value === selectedFilters.country) || countries[0]}
          onChange={event => {
            setSelectedFilters({
              ...selectedFilters,
              country: event.value
            })
          }}
          options={countries}
          data-testid="countyCodeSelect"
          showPrefixForSelectedOption
          borderRadiiSize="large"
        />
      </Box>
    </>
  )
}
